export const passiveRestraintItems = [
  { value: 'none', label: 'None' },
  {
    value: 'passenger_seatbelt',
    label: 'Passenger Seatbelt',
  },
  { value: 'single_airbag', label: 'Single Airbag' },
  { value: 'double_airbag', label: 'Double Airbag' },
];
